export const REQUEST_GET_PREOPEN_MANAGER_FEE_NOTE =
  'REQUEST_GET_PREOPEN_MANAGER_FEE_NOTE';
export const SET_FEE_NOTES_GPO = 'SET_FEE_NOTES_GPO';
export const REQUEST_SEARCH_PREOPEN_MANAGER_FEE_NOTE =
  'REQUEST_SEARCH_PREOPEN_MANAGER_FEE_NOTE';
